import React, { PropsWithChildren } from 'react';

interface XSAndSMDivProps {
    className?: string
    id?: string
    style?: React.CSSProperties
}

const XSAndSMDiv = (props: PropsWithChildren<XSAndSMDivProps>) => {
    const classes = props.className ? `visible-sm ${props.className}` : 'visible-sm';
    return <>
        <div
            {...props}
            className={classes}
        >
            {props.children}
        </div>
    </>;
};

export default XSAndSMDiv;